module.exports = __webpack_public_path__ + "img/hr-tree-01-j-leaves.4e23a558.png";